export const languages = [
  {
    value: 'fr',
    fr: 'Français',
    en: 'French'
  },
  {
    value: 'sq',
    fr: 'Albanais',
    en: 'Albanian'
  },
  {
    value: 'de',
    fr: 'Allemand',
    en: 'German'
  },
  {
    value: 'en',
    fr: 'Anglais',
    en: 'English'
  },
  {
    value: 'ar',
    fr: 'Arabe',
    en: 'Arabic'
  },
  {
    value: 'hy',
    fr: 'Arménien',
    en: 'Armenian'
  },
  {
    value: 'bn',
    fr: 'Bengali',
    en: 'Bengali'
  },
  {
    value: 'ca',
    fr: 'Catalan',
    en: 'Catalan/Valencian'
  },
  {
    value: 'zh',
    fr: 'Chinois',
    en: 'Chinese'
  },
  {
    value: 'ko',
    fr: 'Coréen',
    en: 'Korean'
  },
  {
    value: 'ht',
    fr: 'Créole/Haïtien',
    en: 'Haitian/Haitian Creole'
  },
  {
    value: 'hr',
    fr: 'Croate',
    en: 'Croatian'
  },
  {
    value: 'da',
    fr: 'Danois',
    en: 'Danish'
  },
  {
    value: 'es',
    fr: 'Espagnol',
    en: 'Spanish/Castilian'
  },
  {
    value: 'et',
    fr: 'Estonien',
    en: 'Estonian'
  },
  {
    value: 'fi',
    fr: 'Finnois',
    en: 'Finnish'
  },
  {
    value: 'ka',
    fr: 'Géorgien',
    en: 'Georgian'
  },
  {
    value: 'el',
    fr: 'Grec',
    en: 'Greek, Modern(1453-)'
  },
  {
    value: 'hi',
    fr: 'Hindi',
    en: 'Hindi'
  },
  {
    value: 'hu',
    fr: 'Hongrois',
    en: 'Hungarian'
  },
  {
    value: 'id',
    fr: 'Indonésien',
    en: 'Indonesian'
  },
  {
    value: 'ga',
    fr: 'Irlandais',
    en: 'Irish'
  },
  {
    value: 'is',
    fr: 'Islandais',
    en: 'Icelandic'
  },
  {
    value: 'it',
    fr: 'Italien',
    en: 'Italian'
  },
  {
    value: 'ja',
    fr: 'Japonais',
    en: 'Japanese'
  },
  {
    value: 'lt',
    fr: 'Lituanien',
    en: 'Lithuanian'
  },
  {
    value: 'lb',
    fr: 'Luxembourgeois',
    en: 'Luxembourgish/Letzeburgesch'
  },
  {
    value: 'mk',
    fr: 'Macédonien',
    en: 'Macedonian'
  },
  {
    value: 'mt',
    fr: 'Maltais',
    en: 'Maltese'
  },
  {
    value: 'nl',
    fr: 'Néerlandais',
    en: 'Dutch/Flemish'
  },
  {
    value: 'no',
    fr: 'Norvégien',
    en: 'Norwegian'
  },
  {
    value: 'pl',
    fr: 'Polonais',
    en: 'Polish'
  },
  {
    value: 'pt',
    fr: 'Portugais',
    en: 'Portuguese'
  },
  {
    value: 'ro',
    fr: 'Roumain',
    en: 'Romanian/Moldavian/Moldovan'
  },
  {
    value: 'ru',
    fr: 'Russe',
    en: 'Russian'
  },
  {
    value: 'sk',
    fr: 'Slovaque',
    en: 'Slovak'
  },
  {
    value: 'sl',
    fr: 'Slovène',
    en: 'Slovenian'
  },
  {
    value: 'sv',
    fr: 'Suédois',
    en: 'Swedish'
  },
  {
    value: 'cs',
    fr: 'Tchèque',
    en: 'Czech'
  },
  {
    value: 'tr',
    fr: 'Turc',
    en: 'Turkish'
  }
]
